// src/components/MusicTaskItem.jsx
import React from "react";

function formatDate(d) {
  if (!d) return "";
  try {
    return new Intl.DateTimeFormat("es-MX", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(d);
  } catch {
    return String(d);
  }
}

export default function MusicTaskItem({ task, onOpen }) {
  return (
    <div
      className="mt-item"
      onClick={() => onOpen?.(task)}
      role={onOpen ? "button" : undefined}
      style={{
        border: "1px solid rgba(0,0,0,.10)",
        borderRadius: 12,
        padding: 12,
        background: "#fff",
        cursor: onOpen ? "pointer" : "default",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
        <div style={{ fontWeight: 800 }}>{task.id}</div>
        <div style={{ opacity: 0.75, whiteSpace: "nowrap" }}>
          {formatDate(task.createdAt)}
        </div>
      </div>

      <div style={{ marginTop: 8, display: "grid", gap: 6 }}>
        <div>
          <b>idCancion:</b> {task.idCancion || "-"}
        </div>
        <div>
          <b>idUser:</b> {task.idUser || "-"}
        </div>
        <div>
          <b>mode:</b> {task.mode || "-"}
        </div>
      </div>
    </div>
  );
}